import React from "react";
import CartItem from "../components/cart/cartItem";

const Cart=()=>{

    return(
        <div>
<CartItem/>

        </div>
    )
}
export default Cart;